import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/img/fugao.png'


const _hoisted_1 = { class: "pick-up-content" }

import {onMounted, ref} from "vue";
import weChatObituaryApi from "@/utils/Api/WeChatObituary";
import commMethods from "@/assets/ts/common";
import { showToast } from 'vant';
import {useRoute,useRouter} from 'vue-router'

export default /*@__PURE__*/_defineComponent({
  __name: 'pickup',
  setup(__props) {

const route=useRoute();
const router=useRouter();
const receivePhone = ref('');

onMounted(()=>{
  document.title='领取讣告'
  console.log('zzzz',route.query)
  obituaryShare();
})

const loading=ref(false);
const error=ref('')
const obituaryShare=()=>{
  weChatObituaryApi.share(route.query.id).then(res=>{
    console.log(res)
  })
}
//领取讣告
const receiveObituary=()=>{
  loading.value=true;
  console.log('zzz4z',route.query)
// alert(JSON.stringify({
//   "obituaryId": route.query.obituaryId,
//   "openid": commMethods.getStorage('info').openid,
//   "receivePhone": receivePhone.value
// }))
  weChatObituaryApi.receiveObituary({
    "obituaryId": route.query.id,
    "openid": commMethods.getStorage('info').openid,
    "receivePhone": receivePhone.value
  }).then(res=>{
    error.value='1'
    showToast({
      message:'绑定成功',
      onOpened(){
        router.push('/')
      }
    });
  }).catch(err=> {
    showToast({
      message:'手机号不一致'
    });
  }).finally(()=>{
    loading.value=false;
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("img", {
      class: "img",
      src: _imports_0
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text" }, "请正确输入预留手机号", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text" }, "关系到您是否能收到之后的祭日提醒", -1)),
    _withDirectives(_createElementVNode("input", {
      class: "input",
      type: "number",
      maxlength: "11",
      placeholder: "预留手机号码",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((receivePhone).value = $event))
    }, null, 512), [
      [_vModelText, receivePhone.value]
    ]),
    _createElementVNode("button", {
      class: "colorful-btn",
      onClick: receiveObituary
    }, "领取讣告")
  ]))
}
}

})